import { PdfGen, PdfUnit, PdfSize, PdfRect } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';
import '../../pdf/draw/arrow';

export class Sipky implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const itemsPerPage = 10;

    const itemCount = Math.min(opts.list.length, 50);

    const landscapePageCount = Math.ceil(itemCount / itemsPerPage);
    const portraitPageCount = Math.ceil(itemCount / itemsPerPage);

    const colors = GUtil.randomBrushes(opts.data.random, [
      [
        '#2e1c9b',
        '#2d1da2',
        '#2c1da8',
        '#2b1eae',
        '#2a1eb5',
        '#291fbb',
        '#281fc1',
        '#261fc8',
        '#241fce',
        '#231fd5',
      ],
      [
        '#13c684',
        '#11c599',
        '#12c5ad',
        '#16c3c0',
        '#1bc2d3',
        '#48c6d5',
        '#77cec7',
        '#9cd6b8',
        '#bddda6',
        '#dce391',
      ],
      [
        '#b92e59',
        '#c63565',
        '#ce4371',
        '#d3547c',
        '#d8648b',
        '#de749a',
        '#e385a5',
        '#e996b3',
        '#eea6bf',
        '#f4b7ca',
      ],
    ]);

    for (let p = 0; p < landscapePageCount; p++) {
      const page = pdf.addPage(true);
      const startIndex = p * itemsPerPage;
      const endIndex = Math.min(startIndex + itemsPerPage, itemCount);
      const pageItems = opts.list.slice(startIndex, endIndex);

      const size1W = PdfSize.A4.height / 5;
      const size1H = PdfSize.A4.width / 2;

      const pageTexts = pageItems.map((item) => [item.left.getText() ?? '']);
      const labelFont = page.adjustFontMulti(
        pageTexts,
        GUtil.baseFont,
        new PdfSize(size1W - 2 * margin, size1H / 2 - margin)
      );

      for (let x = 0; x < 5; x++) {
        for (let y = 0; y < 2; y++) {
          const indexOnPage = y * 5 + x;
          if (indexOnPage >= pageItems.length) continue;

          const item = pageItems[indexOnPage];
          const itemIndex = startIndex + indexOnPage;

          const rect1 = new PdfRect(x * size1W, y * size1H, size1W, size1H);
          const r1 = new PdfRect(
            rect1.left + margin,
            rect1.top + margin,
            rect1.width - 2 * margin,
            rect1.height - 2 * margin
          );

          const ra1 = new PdfRect(r1.left, r1.top, r1.width, r1.height / 2);
          const rl1 = new PdfRect(ra1.left, ra1.bottom, ra1.width, ra1.height);

          page.drawRectangle(GUtil.cutPen, null, rect1);
          page.drawLabel(item.left, { rect: rl1, font: labelFont });
          page.drawArrowUp(ra1, colors[itemIndex % colors.length]);
        }
      }
    }

    for (let p = 0; p < portraitPageCount; p++) {
      const page = pdf.addPage();
      const startIndex = p * itemsPerPage;
      const endIndex = Math.min(startIndex + itemsPerPage, itemCount);
      const pageItems = opts.list.slice(startIndex, endIndex);

      const size2W = PdfSize.A4.width / 2;
      const size2H = PdfSize.A4.height / 5;

      const pageTexts = pageItems.map((item) => [item.left.getText() ?? '']);
      const labelFont = page.adjustFontMulti(
        pageTexts,
        GUtil.baseFont,
        new PdfSize(size2W / 2 - margin, size2H - 2 * margin)
      );

      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
          const indexOnPage = y * 2 + x;
          if (indexOnPage >= pageItems.length) continue;

          const item = pageItems[indexOnPage];
          const itemIndex = startIndex + indexOnPage;

          const rect2 = new PdfRect(x * size2W, y * size2H, size2W, size2H);
          const r2 = new PdfRect(
            rect2.left + margin,
            rect2.top + margin,
            rect2.width - 2 * margin,
            rect2.height - 2 * margin
          );

          const ra2 = new PdfRect(r2.left, r2.top, r2.width / 2, r2.height);
          const rl2 = new PdfRect(ra2.right, ra2.top, ra2.width, ra2.height);

          page.drawRectangle(GUtil.cutPen, null, rect2);
          page.drawLabel(item.left, { rect: rl2, font: labelFont });
          page.drawArrowLeft(ra2, colors[itemIndex % colors.length]);
        }
      }
    }
  }
}
